import React from 'react'
import CounterSection from '../component/Home/counter'
import TeamContent from '../component/Home/team'
// import TestimonialSlider from '../component/testimonial'
import Breadcrumb from '../common/Breadcrumb'

const AboutContent = () => {
  return (
    <>
      <Breadcrumb 
            pageTitle="About Pioneer"
            breadcrumbItems={[
                { label: "Home", link: "/" },
                { label: "About Pioneer" }
            ]}
            backgroundImage="images/banner/slide-2.png"
        />

    <section class="space-ptb">
      <div class="container">
        <div className='row'>
            <div className='col-md-12'>
                <h2 class="title text-center mb-4"><span class="text-primary"> About Pioneer</span></h2>
               <div className="curved-line mx-auto mt-3"></div>
            </div>

        </div>
        <div class="row align-items-start">
          
          <div class="col-md-6">
            <div class="section-title mb-4 pr-lg-5 px-4 px-lg-2">
                           
              <p className='lead'>In the year 1963, Professor Pooran Singh, a true Pioneer and visionary gave shape to his dream of educating the upcoming generations. Our manager says dedication, and passion led to the establishment of first ever branch of Pioneer School in Rajendra Nagar in the year 1963. Started in only two rooms institution now has crawling campus spread over Lucknow and Barabanki. Pioneer was a small sapling planted by Professor Pooran Singh, and it has grown into a flourishing tree, which continues to spread its branches. Since its inception, Pioneer has completed 59 years in this field of education and entered into the 63rd year of selfless and dedicated Educational service of Lucknow and Barabanki. Pioneer family stands firm in 17 branches, including 1 degree College for teachers having science and  Since its inception, Pioneer has completed 62 years in the field of education and has entered its 63rd year of selfless and dedicated educational service in Lucknow and Barabanki. Pioneer family stands firm in 15 branches having science and commerce streams.
              </p>
              <p className='lead'>Led by Professor Puran Singh, guiding a strength and our motivation. Pioneer has been providing and will continue to provide quality education. Alfred Lord Tennyson, once wrote ,”to strive ,to seek , to find and not to yield.” 
</p>
              <p  className='lead'>Let your child share his dream with us, and we will work together to help him achieve it.</p>
            </div>            
          </div>
          <div class="col-md-6">
              <img src="images/about/aboutnew-2.png" className='w-100 img-redius' alt='' style={{objectFit:'cover'}} />
          </div>
        </div>
      </div>
    </section>

    <CounterSection />

    <TeamContent />
    {/* <TestimonialSlider /> */}
    </>
  )
}

export default AboutContent
